import {
  ContactInfo,
  ContactInfoServiceClient,
} from '../proto/accountpb/contactinfo_grpc_web_pb';

import { auth } from '../lib/auth/Auth';
const service = new ContactInfoServiceClient(window.env.GRPC_ENDPOINT, {}, { ...auth });

export async function createContactInfo(accountId, param, ownerId) {
  return new Promise((resolve, reject) => {
    const req = new ContactInfo();
    req.setOwnerId(ownerId);
    req.setContactInfoId(param.contactInfoId);
    req.setAccountId(accountId);
    req.setContactInfoType(param.contactInfoType);
    req.setContactInfo(param.contactInfo);
    req.setStatus(param.status);

    service.createContactInfo(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function updateContactInfo(accountId, param) {
  return new Promise((resolve, reject) => {
    const req = new ContactInfo();
    req.setContactInfoId(param.contactInfoId);
    req.setAccountId(accountId);
    req.setOwnerId(param.ownerId);
    req.setContactInfoType(param.contactInfoType);
    req.setContactInfo(param.contactInfo);
    req.setStatus(param.status);

    service.updateContactInfo(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

export async function listContactInfo(param) {
  return new Promise((resolve, reject) => {
    const req = new ContactInfo();
    req.setAccountId(param.accountId);
    req.setOwnerId(param.ownerId);

    service.listContactInfo(req, {}, (error, response) => {
      if (error) {
        reject(error);
      } else {
        resolve(response.toObject());
      }
    });
  });
}

const GetValueByOjbectName = (name, d) => {
  if (Object.prototype.hasOwnProperty.call(d, name)) {
    return d[name];
  }
  return '';
};

export const validateEntries = (d) => {
  if (!GetValueByOjbectName('Contact Info Type', d)) {
    return true;
  }

  if (!GetValueByOjbectName('Contact Info', d)) {
    return true;
  }

  return false;
};
